<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateEditUserModal
      v-if="showCreateEditUserModal"
      :userId="userIdSelected"
      @closeModal="closeCreateEditUserModal"
    />
    <PermissionsUserModal
      v-if="showPermissionsUserModal"
      :userId="userIdSelected"
      @closeModal="closePermissionsUserModal"
    />
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Usuários</h5>
        <div v-if="getModuleUserByCode('0.01.002')">
          <button
            type="button"
            class="btn btn-primary"
            title="Novo Usuário"
            @click="createEditUser()"
          >
            Novo Usuário
          </button>
        </div>
      </div>
      <div class="card-body">
        <ListUsers
          :users="users"
          @editUser="createEditUser"
          @permissionsUser="permissionsUser"
        />
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import CreateEditUserModal from '@/components/administration/users/CreateEditUserModal.vue'
import PermissionsUserModal from '@/components/administration/users/PermissionsUserModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListUsers from '@/components/administration/users/ListUsers.vue'

export default {
  name: 'Users',

  components: {
    Layout,
    PageHeader,
    CreateEditUserModal,
    PermissionsUserModal,
    LoadingData,
    ListUsers,
  },

  data() {
    return {
      title: 'Usuários',
      items: [
        {
          text: 'Administração',
        },
        {
          text: 'Usuários',
          active: true,
        },
      ],
      loadData: true,
      showCreateEditUserModal: false,
      showPermissionsUserModal: false,
      users: null,
      userIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    async getUsers() {
      try {
        this.users = await this.$store.dispatch('getUsers')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    createEditUser(userId) {
      this.userIdSelected = userId || null
      this.showCreateEditUserModal = true
    },

    permissionsUser(userId) {
      this.userIdSelected = userId || null
      this.showPermissionsUserModal = true
    },

    closeCreateEditUserModal(loadListUsers) {
      if (loadListUsers) {
        this.getUsers()
      }
      this.showCreateEditUserModal = false
    },

    closePermissionsUserModal() {
      this.showPermissionsUserModal = false
    },
  },

  mounted() {
    this.getUsers()
  },
}
</script>
